import React from 'react';

import { Download, Search, Sparkles } from 'lucide-react';

import Button from 'common/uiV3/Button';
import HStack from 'common/uiV3/HStack';
import Input from 'common/uiV3/Input';
import Spinner from 'common/uiV3/Spinner';

import FiltersDropdown, { type SortOptions } from './FiltersDropdown';

type Filters = {
  onlyInternalComments: boolean;
  search: string;
  segment: string;
  sort: SortOptions;
};

type Props = {
  canExportComments: boolean;
  canSearch: boolean;
  canSummarize: boolean;
  filterLoading: boolean;
  filters: Filters;
  onExportComments: () => void;
  onFiltersChange: (filters: Filters) => void;
  onSummarize: () => void;
  summarizeLoading: boolean;
};

const AdminHeader = ({
  canExportComments,
  canSearch,
  canSummarize,
  filterLoading,
  filters: { onlyInternalComments, search, segment, sort },
  onExportComments,
  onFiltersChange,
  summarizeLoading,
  onSummarize,
}: Props) => {
  return (
    <HStack className="items-center gap-2 justify-between">
      {canSearch ? (
        <div className="max-w-[280px] flex-1">
          <Input
            onChange={(search) =>
              onFiltersChange({
                onlyInternalComments,
                search,
                segment,
                sort,
              })
            }
            placeholder="Search activity..."
            startIcon={filterLoading ? undefined : Search}
            prefix={filterLoading ? <Spinner /> : undefined}
            value={search}
          />
        </div>
      ) : (
        <span className="text-base text-gray-110">Activity Feed</span>
      )}

      <HStack className="items-center gap-2">
        {canSummarize ? (
          <Button
            aria-type="dialog"
            onClick={onSummarize}
            isLoading={summarizeLoading}
            variant="outlined">
            <Sparkles />
            Summarize
          </Button>
        ) : null}
        <FiltersDropdown
          loading={filterLoading}
          onChange={(filters: Omit<Filters, 'search'>) => onFiltersChange({ ...filters, search })}
          onlyInternalComments={onlyInternalComments}
          segment={segment}
          sort={sort}
        />
        {canExportComments ? (
          <Button
            variant="outlined"
            onClick={onExportComments}
            aria-label="export comments"
            iconOnly>
            <Download />
          </Button>
        ) : null}
      </HStack>
    </HStack>
  );
};

export default AdminHeader;
